import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useWatchAuth } from '@/hooks/useWatchAuth'

export default function WatchLogin() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const { login, checkAuth, isAuthenticated } = useWatchAuth()
  const navigate = useNavigate()

  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/watch')
    }
  }, [isAuthenticated, navigate])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      await login(username, password)
      navigate('/watch')
    } catch (err) {
      if (err instanceof Error && err.message.includes('Web player not enabled')) {
        setError('Web player access is not enabled for this account')
      } else {
        setError('Invalid username or password')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-sidebar px-4">
      <div className="w-full max-w-sm space-y-8">
        <div className="text-center">
          <div className="flex items-center justify-center mb-6">
            <img src="/logo.png" alt="OBACast" className="h-20 w-auto" />
          </div>
          <h1 className="text-2xl font-bold text-sidebar-foreground mb-2">Web Player</h1>
          <p className="text-base text-sidebar-foreground/60">
            Sign in to start watching
          </p>
        </div>

        <form className="space-y-6" onSubmit={handleSubmit}>
          {error && (
            <div className="bg-destructive/10 border border-destructive/20 text-destructive px-4 py-3 rounded-lg text-base">
              {error}
            </div>
          )}

          <div className="space-y-4">
            <div>
              <label htmlFor="username" className="block mb-2 text-sm font-medium text-sidebar-foreground/80">
                Username
              </label>
              <input
                id="username"
                name="username"
                type="text"
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full h-12 px-4 bg-sidebar-muted border border-sidebar-muted rounded-lg text-base text-sidebar-foreground placeholder:text-sidebar-foreground/50 focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/20 transition-all duration-200"
                placeholder="Enter your username"
              />
            </div>
            <div>
              <label htmlFor="password" className="block mb-2 text-sm font-medium text-sidebar-foreground/80">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full h-12 px-4 bg-sidebar-muted border border-sidebar-muted rounded-lg text-base text-sidebar-foreground placeholder:text-sidebar-foreground/50 focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/20 transition-all duration-200"
                placeholder="Enter your password"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full h-12 bg-primary hover:bg-primary/90 disabled:bg-primary/50 text-primary-foreground font-medium rounded-lg transition-colors duration-200"
          >
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>

        <p className="text-center text-sm text-sidebar-foreground/50">
          Contact your administrator if you need access
        </p>
      </div>
    </div>
  )
}
